import { Link } from "react-router";
import PageLayout from "@/components/Shared/PageLayout";
import { Card, H3 } from "@/components/Shared/UI";

const Support = () => {
  return (
    <PageLayout title="Support">
      <Card className="flex flex-col items-center p-8">
        <div className="linkify max-w-xl text-center">
          <H3>Support</H3>
          <p className="mt-3">
            For assistance, please email us at{" "}
            <Link to="mailto:shivabajpai2006@gmail.com">support@relayr.com</Link> with a
            detailed description of your issue and how we can assist you.
          </p>
          <div className="my-5 flex flex-col space-y-2">
            <Link to="#">Relayr Privacy Policy</Link>
            <Link to="#">Terms of Service</Link>
            <Link to="#">Copyright Policy</Link>
          </div>
          <p className="text-gray-500 text-sm">
            Send any query regrading careers at relayr to{" "}
            <Link to="mailto:shivabajpai2006@gmail.com">careers@relayr.com</Link>
          </p>
        </div>
      </Card>
    </PageLayout>
  );
};

export default Support;
